/**
 * Auto-generated country dataset — DO NOT EDIT MANUALLY.
 * Source: https://raw.githubusercontent.com/dr5hn/countries-states-cities-database/master/json/countries.json
 * Generated: 2026-06-19T15:29:10.745Z
 * Countries: 250
 */

export function iso2ToFlag(iso2: string): string {
  return [...iso2.toUpperCase()]
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join('');
}

import type { ICountry } from '../types';

export const COUNTRIES: ICountry[] = [
  {
    "name": "Afghanistan",
    "iso2": "AF",
    "iso3": "AFG",
    "phone_code": "93",
    "division_type": "Province",
    "flag": "🇦🇫",
    "flag_url": "https://flagcdn.com/w320/af.png",
    "language_code": "ps",
    "currency_code": "AFN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-MM-DD",
    "date_separator": "-",
    "week_start": 6
  },
  {
    "name": "Aland Islands",
    "iso2": "AX",
    "iso3": "ALA",
    "phone_code": "358",
    "division_type": "Municipality",
    "flag": "🇦🇽",
    "flag_url": "https://flagcdn.com/w320/ax.png",
    "language_code": "sv",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-MM-DD",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Albania",
    "iso2": "AL",
    "iso3": "ALB",
    "phone_code": "355",
    "division_type": "County",
    "flag": "🇦🇱",
    "flag_url": "https://flagcdn.com/w320/al.png",
    "language_code": "sq",
    "currency_code": "ALL",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Algeria",
    "iso2": "DZ",
    "iso3": "DZA",
    "phone_code": "213",
    "division_type": "Province",
    "flag": "🇩🇿",
    "flag_url": "https://flagcdn.com/w320/dz.png",
    "language_code": "ar",
    "currency_code": "DZD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "American Samoa",
    "iso2": "AS",
    "iso3": "ASM",
    "phone_code": "1",
    "division_type": "Atoll or District",
    "flag": "🇦🇸",
    "flag_url": "https://flagcdn.com/w320/as.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Andorra",
    "iso2": "AD",
    "iso3": "AND",
    "phone_code": "376",
    "division_type": "Parish",
    "flag": "🇦🇩",
    "flag_url": "https://flagcdn.com/w320/ad.png",
    "language_code": "ca",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Angola",
    "iso2": "AO",
    "iso3": "AGO",
    "phone_code": "244",
    "division_type": "Province",
    "flag": "🇦🇴",
    "flag_url": "https://flagcdn.com/w320/ao.png",
    "language_code": "pt",
    "currency_code": "AOA",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Anguilla",
    "iso2": "AI",
    "iso3": "AIA",
    "phone_code": "1",
    "division_type": "District",
    "flag": "🇦🇮",
    "flag_url": "https://flagcdn.com/w320/ai.png",
    "language_code": "en",
    "currency_code": "XCD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Antarctica",
    "iso2": "AQ",
    "iso3": "ATA",
    "phone_code": "672",
    "division_type": "",
    "flag": "🇦🇶",
    "flag_url": "https://flagcdn.com/w320/aq.png",
    "language_code": "en",
    "currency_code": "AAD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Antigua and Barbuda",
    "iso2": "AG",
    "iso3": "ATG",
    "phone_code": "1",
    "division_type": "Dependency or Parish",
    "flag": "🇦🇬",
    "flag_url": "https://flagcdn.com/w320/ag.png",
    "language_code": "en",
    "currency_code": "XCD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Argentina",
    "iso2": "AR",
    "iso3": "ARG",
    "phone_code": "54",
    "division_type": "City or Province",
    "flag": "🇦🇷",
    "flag_url": "https://flagcdn.com/w320/ar.png",
    "language_code": "es",
    "currency_code": "ARS",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Armenia",
    "iso2": "AM",
    "iso3": "ARM",
    "phone_code": "374",
    "division_type": "City or Region",
    "flag": "🇦🇲",
    "flag_url": "https://flagcdn.com/w320/am.png",
    "language_code": "hy",
    "currency_code": "AMD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Aruba",
    "iso2": "AW",
    "iso3": "ABW",
    "phone_code": "297",
    "division_type": "Capital city or Region",
    "flag": "🇦🇼",
    "flag_url": "https://flagcdn.com/w320/aw.png",
    "language_code": "nl",
    "currency_code": "AWG",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD-MM-YYYY",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Australia",
    "iso2": "AU",
    "iso3": "AUS",
    "phone_code": "61",
    "division_type": "State or Territory",
    "flag": "🇦🇺",
    "flag_url": "https://flagcdn.com/w320/au.png",
    "language_code": "en-AU",
    "currency_code": "AUD",
    "tax_id_label": "ABN",
    "tax_id_placeholder": "00 000 000 000",
    "postal_code_label": "Postcode",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Austria",
    "iso2": "AT",
    "iso3": "AUT",
    "phone_code": "43",
    "division_type": "State",
    "flag": "🇦🇹",
    "flag_url": "https://flagcdn.com/w320/at.png",
    "language_code": "de",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Azerbaijan",
    "iso2": "AZ",
    "iso3": "AZE",
    "phone_code": "994",
    "division_type": "Autonomous republic or District or Municipality",
    "flag": "🇦🇿",
    "flag_url": "https://flagcdn.com/w320/az.png",
    "language_code": "az",
    "currency_code": "AZN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Bahrain",
    "iso2": "BH",
    "iso3": "BHR",
    "phone_code": "973",
    "division_type": "Governorate",
    "flag": "🇧🇭",
    "flag_url": "https://flagcdn.com/w320/bh.png",
    "language_code": "ar",
    "currency_code": "BHD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Bangladesh",
    "iso2": "BD",
    "iso3": "BGD",
    "phone_code": "880",
    "division_type": "District or Division",
    "flag": "🇧🇩",
    "flag_url": "https://flagcdn.com/w320/bd.png",
    "language_code": "bn",
    "currency_code": "BDT",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Barbados",
    "iso2": "BB",
    "iso3": "BRB",
    "phone_code": "1",
    "division_type": "Parish",
    "flag": "🇧🇧",
    "flag_url": "https://flagcdn.com/w320/bb.png",
    "language_code": "en",
    "currency_code": "BBD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Belarus",
    "iso2": "BY",
    "iso3": "BLR",
    "phone_code": "375",
    "division_type": "City or Oblast",
    "flag": "🇧🇾",
    "flag_url": "https://flagcdn.com/w320/by.png",
    "language_code": "be",
    "currency_code": "BYN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Belgium",
    "iso2": "BE",
    "iso3": "BEL",
    "phone_code": "32",
    "division_type": "Province or Region",
    "flag": "🇧🇪",
    "flag_url": "https://flagcdn.com/w320/be.png",
    "language_code": "nl",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Belize",
    "iso2": "BZ",
    "iso3": "BLZ",
    "phone_code": "501",
    "division_type": "District",
    "flag": "🇧🇿",
    "flag_url": "https://flagcdn.com/w320/bz.png",
    "language_code": "en",
    "currency_code": "BZD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Benin",
    "iso2": "BJ",
    "iso3": "BEN",
    "phone_code": "229",
    "division_type": "Department",
    "flag": "🇧🇯",
    "flag_url": "https://flagcdn.com/w320/bj.png",
    "language_code": "fr",
    "currency_code": "XOF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Bermuda",
    "iso2": "BM",
    "iso3": "BMU",
    "phone_code": "1",
    "division_type": "Municipality",
    "flag": "🇧🇲",
    "flag_url": "https://flagcdn.com/w320/bm.png",
    "language_code": "en",
    "currency_code": "BMD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Bhutan",
    "iso2": "BT",
    "iso3": "BTN",
    "phone_code": "975",
    "division_type": "District",
    "flag": "🇧🇹",
    "flag_url": "https://flagcdn.com/w320/bt.png",
    "language_code": "dz",
    "currency_code": "BTN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-MM-DD",
    "date_separator": "-",
    "week_start": 0
  },
  {
    "name": "Bolivia",
    "iso2": "BO",
    "iso3": "BOL",
    "phone_code": "591",
    "division_type": "Department",
    "flag": "🇧🇴",
    "flag_url": "https://flagcdn.com/w320/bo.png",
    "language_code": "es",
    "currency_code": "BOB",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Bonaire, Sint Eustatius and Saba",
    "iso2": "BQ",
    "iso3": "BES",
    "phone_code": "599",
    "division_type": "Special municipality",
    "flag": "🇧🇶",
    "flag_url": "https://flagcdn.com/w320/bq.png",
    "language_code": "nl",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD-MM-YYYY",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Bosnia and Herzegovina",
    "iso2": "BA",
    "iso3": "BIH",
    "phone_code": "387",
    "division_type": "District or Entity",
    "flag": "🇧🇦",
    "flag_url": "https://flagcdn.com/w320/ba.png",
    "language_code": "bs",
    "currency_code": "BAM",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Botswana",
    "iso2": "BW",
    "iso3": "BWA",
    "phone_code": "267",
    "division_type": "City or District or Town",
    "flag": "🇧🇼",
    "flag_url": "https://flagcdn.com/w320/bw.png",
    "language_code": "en",
    "currency_code": "BWP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Bouvet Island",
    "iso2": "BV",
    "iso3": "BVT",
    "phone_code": "0055",
    "division_type": "",
    "flag": "🇧🇻",
    "flag_url": "https://flagcdn.com/w320/bv.png",
    "language_code": "no",
    "currency_code": "NOK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Brazil",
    "iso2": "BR",
    "iso3": "BRA",
    "phone_code": "55",
    "division_type": "Federal district or State",
    "flag": "🇧🇷",
    "flag_url": "https://flagcdn.com/w320/br.png",
    "language_code": "pt-BR",
    "currency_code": "BRL",
    "tax_id_label": "CNPJ",
    "tax_id_placeholder": "00.000.000/0000-00",
    "postal_code_label": "CEP",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "British Indian Ocean Territory",
    "iso2": "IO",
    "iso3": "IOT",
    "phone_code": "246",
    "division_type": "",
    "flag": "🇮🇴",
    "flag_url": "https://flagcdn.com/w320/io.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Brunei",
    "iso2": "BN",
    "iso3": "BRN",
    "phone_code": "673",
    "division_type": "District",
    "flag": "🇧🇳",
    "flag_url": "https://flagcdn.com/w320/bn.png",
    "language_code": "ms",
    "currency_code": "BND",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Bulgaria",
    "iso2": "BG",
    "iso3": "BGR",
    "phone_code": "359",
    "division_type": "District",
    "flag": "🇧🇬",
    "flag_url": "https://flagcdn.com/w320/bg.png",
    "language_code": "bg",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Burkina Faso",
    "iso2": "BF",
    "iso3": "BFA",
    "phone_code": "226",
    "division_type": "Province or Region",
    "flag": "🇧🇫",
    "flag_url": "https://flagcdn.com/w320/bf.png",
    "language_code": "fr",
    "currency_code": "XOF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Burundi",
    "iso2": "BI",
    "iso3": "BDI",
    "phone_code": "257",
    "division_type": "Province",
    "flag": "🇧🇮",
    "flag_url": "https://flagcdn.com/w320/bi.png",
    "language_code": "fr",
    "currency_code": "BIF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Cambodia",
    "iso2": "KH",
    "iso3": "KHM",
    "phone_code": "855",
    "division_type": "Autonomous municipality or Province",
    "flag": "🇰🇭",
    "flag_url": "https://flagcdn.com/w320/kh.png",
    "language_code": "km",
    "currency_code": "KHR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Cameroon",
    "iso2": "CM",
    "iso3": "CMR",
    "phone_code": "237",
    "division_type": "Region",
    "flag": "🇨🇲",
    "flag_url": "https://flagcdn.com/w320/cm.png",
    "language_code": "fr",
    "currency_code": "XAF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Canada",
    "iso2": "CA",
    "iso3": "CAN",
    "phone_code": "1",
    "division_type": "Province or Territory",
    "flag": "🇨🇦",
    "flag_url": "https://flagcdn.com/w320/ca.png",
    "language_code": "en-CA",
    "currency_code": "CAD",
    "tax_id_label": "BN / GST/HST Number",
    "tax_id_placeholder": "000000000",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Cape Verde",
    "iso2": "CV",
    "iso3": "CPV",
    "phone_code": "238",
    "division_type": "Geographical region or Municipality",
    "flag": "🇨🇻",
    "flag_url": "https://flagcdn.com/w320/cv.png",
    "language_code": "pt",
    "currency_code": "CVE",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Cayman Islands",
    "iso2": "KY",
    "iso3": "CYM",
    "phone_code": "1",
    "division_type": "",
    "flag": "🇰🇾",
    "flag_url": "https://flagcdn.com/w320/ky.png",
    "language_code": "en",
    "currency_code": "KYD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Central African Republic",
    "iso2": "CF",
    "iso3": "CAF",
    "phone_code": "236",
    "division_type": "Commune or Economic prefecture or Prefecture",
    "flag": "🇨🇫",
    "flag_url": "https://flagcdn.com/w320/cf.png",
    "language_code": "fr",
    "currency_code": "XAF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Chad",
    "iso2": "TD",
    "iso3": "TCD",
    "phone_code": "235",
    "division_type": "Province",
    "flag": "🇹🇩",
    "flag_url": "https://flagcdn.com/w320/td.png",
    "language_code": "fr",
    "currency_code": "XAF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Chile",
    "iso2": "CL",
    "iso3": "CHL",
    "phone_code": "56",
    "division_type": "Region",
    "flag": "🇨🇱",
    "flag_url": "https://flagcdn.com/w320/cl.png",
    "language_code": "es",
    "currency_code": "CLP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD-MM-YYYY",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "China",
    "iso2": "CN",
    "iso3": "CHN",
    "phone_code": "86",
    "division_type": "Autonomous region or Municipality or Province or Special administrative region",
    "flag": "🇨🇳",
    "flag_url": "https://flagcdn.com/w320/cn.png",
    "language_code": "zh-CN",
    "currency_code": "CNY",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Christmas Island",
    "iso2": "CX",
    "iso3": "CXR",
    "phone_code": "61",
    "division_type": "",
    "flag": "🇨🇽",
    "flag_url": "https://flagcdn.com/w320/cx.png",
    "language_code": "en",
    "currency_code": "AUD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Cocos (Keeling) Islands",
    "iso2": "CC",
    "iso3": "CCK",
    "phone_code": "61",
    "division_type": "",
    "flag": "🇨🇨",
    "flag_url": "https://flagcdn.com/w320/cc.png",
    "language_code": "en",
    "currency_code": "AUD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Colombia",
    "iso2": "CO",
    "iso3": "COL",
    "phone_code": "57",
    "division_type": "Capital district or Department",
    "flag": "🇨🇴",
    "flag_url": "https://flagcdn.com/w320/co.png",
    "language_code": "es",
    "currency_code": "COP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Comoros",
    "iso2": "KM",
    "iso3": "COM",
    "phone_code": "269",
    "division_type": "Island",
    "flag": "🇰🇲",
    "flag_url": "https://flagcdn.com/w320/km.png",
    "language_code": "ar",
    "currency_code": "KMF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Congo",
    "iso2": "CG",
    "iso3": "COG",
    "phone_code": "242",
    "division_type": "Department",
    "flag": "🇨🇬",
    "flag_url": "https://flagcdn.com/w320/cg.png",
    "language_code": "fr",
    "currency_code": "CDF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Cook Islands",
    "iso2": "CK",
    "iso3": "COK",
    "phone_code": "682",
    "division_type": "",
    "flag": "🇨🇰",
    "flag_url": "https://flagcdn.com/w320/ck.png",
    "language_code": "en",
    "currency_code": "NZD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Costa Rica",
    "iso2": "CR",
    "iso3": "CRI",
    "phone_code": "506",
    "division_type": "Province",
    "flag": "🇨🇷",
    "flag_url": "https://flagcdn.com/w320/cr.png",
    "language_code": "es",
    "currency_code": "CRC",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Croatia",
    "iso2": "HR",
    "iso3": "HRV",
    "phone_code": "385",
    "division_type": "County",
    "flag": "🇭🇷",
    "flag_url": "https://flagcdn.com/w320/hr.png",
    "language_code": "hr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Cuba",
    "iso2": "CU",
    "iso3": "CUB",
    "phone_code": "53",
    "division_type": "Province or Special municipality",
    "flag": "🇨🇺",
    "flag_url": "https://flagcdn.com/w320/cu.png",
    "language_code": "es",
    "currency_code": "CUP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Curaçao",
    "iso2": "CW",
    "iso3": "CUW",
    "phone_code": "599",
    "division_type": "",
    "flag": "🇨🇼",
    "flag_url": "https://flagcdn.com/w320/cw.png",
    "language_code": "nl",
    "currency_code": "ANG",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD-MM-YYYY",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Cyprus",
    "iso2": "CY",
    "iso3": "CYP",
    "phone_code": "357",
    "division_type": "District",
    "flag": "🇨🇾",
    "flag_url": "https://flagcdn.com/w320/cy.png",
    "language_code": "el",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Czech Republic",
    "iso2": "CZ",
    "iso3": "CZE",
    "phone_code": "420",
    "division_type": "Capital city or District or Region",
    "flag": "🇨🇿",
    "flag_url": "https://flagcdn.com/w320/cz.png",
    "language_code": "cs",
    "currency_code": "CZK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Democratic Republic of the Congo",
    "iso2": "CD",
    "iso3": "COD",
    "phone_code": "243",
    "division_type": "City or Province",
    "flag": "🇨🇩",
    "flag_url": "https://flagcdn.com/w320/cd.png",
    "language_code": "fr",
    "currency_code": "CDF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Denmark",
    "iso2": "DK",
    "iso3": "DNK",
    "phone_code": "45",
    "division_type": "Region",
    "flag": "🇩🇰",
    "flag_url": "https://flagcdn.com/w320/dk.png",
    "language_code": "da",
    "currency_code": "DKK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Djibouti",
    "iso2": "DJ",
    "iso3": "DJI",
    "phone_code": "253",
    "division_type": "City or Region",
    "flag": "🇩🇯",
    "flag_url": "https://flagcdn.com/w320/dj.png",
    "language_code": "fr",
    "currency_code": "DJF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Dominica",
    "iso2": "DM",
    "iso3": "DMA",
    "phone_code": "1",
    "division_type": "Parish",
    "flag": "🇩🇲",
    "flag_url": "https://flagcdn.com/w320/dm.png",
    "language_code": "en",
    "currency_code": "XCD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Dominican Republic",
    "iso2": "DO",
    "iso3": "DOM",
    "phone_code": "1",
    "division_type": "District or Province or Region",
    "flag": "🇩🇴",
    "flag_url": "https://flagcdn.com/w320/do.png",
    "language_code": "es",
    "currency_code": "DOP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Ecuador",
    "iso2": "EC",
    "iso3": "ECU",
    "phone_code": "593",
    "division_type": "Province",
    "flag": "🇪🇨",
    "flag_url": "https://flagcdn.com/w320/ec.png",
    "language_code": "es",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Egypt",
    "iso2": "EG",
    "iso3": "EGY",
    "phone_code": "20",
    "division_type": "Governorate",
    "flag": "🇪🇬",
    "flag_url": "https://flagcdn.com/w320/eg.png",
    "language_code": "ar",
    "currency_code": "EGP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "El Salvador",
    "iso2": "SV",
    "iso3": "SLV",
    "phone_code": "503",
    "division_type": "Department",
    "flag": "🇸🇻",
    "flag_url": "https://flagcdn.com/w320/sv.png",
    "language_code": "es",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Equatorial Guinea",
    "iso2": "GQ",
    "iso3": "GNQ",
    "phone_code": "240",
    "division_type": "Province or Region",
    "flag": "🇬🇶",
    "flag_url": "https://flagcdn.com/w320/gq.png",
    "language_code": "es",
    "currency_code": "XAF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Eritrea",
    "iso2": "ER",
    "iso3": "ERI",
    "phone_code": "291",
    "division_type": "Region",
    "flag": "🇪🇷",
    "flag_url": "https://flagcdn.com/w320/er.png",
    "language_code": "ti",
    "currency_code": "ERN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Estonia",
    "iso2": "EE",
    "iso3": "EST",
    "phone_code": "372",
    "division_type": "County or Rural municipality or Urban municipality",
    "flag": "🇪🇪",
    "flag_url": "https://flagcdn.com/w320/ee.png",
    "language_code": "et",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Eswatini",
    "iso2": "SZ",
    "iso3": "SWZ",
    "phone_code": "268",
    "division_type": "Region",
    "flag": "🇸🇿",
    "flag_url": "https://flagcdn.com/w320/sz.png",
    "language_code": "en",
    "currency_code": "SZL",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Ethiopia",
    "iso2": "ET",
    "iso3": "ETH",
    "phone_code": "251",
    "division_type": "Administration or Region",
    "flag": "🇪🇹",
    "flag_url": "https://flagcdn.com/w320/et.png",
    "language_code": "am",
    "currency_code": "ETB",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Falkland Islands",
    "iso2": "FK",
    "iso3": "FLK",
    "phone_code": "500",
    "division_type": "",
    "flag": "🇫🇰",
    "flag_url": "https://flagcdn.com/w320/fk.png",
    "language_code": "en",
    "currency_code": "FKP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Faroe Islands",
    "iso2": "FO",
    "iso3": "FRO",
    "phone_code": "298",
    "division_type": "Region",
    "flag": "🇫🇴",
    "flag_url": "https://flagcdn.com/w320/fo.png",
    "language_code": "fo",
    "currency_code": "DKK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Fiji Islands",
    "iso2": "FJ",
    "iso3": "FJI",
    "phone_code": "679",
    "division_type": "Dependency or Division or Province",
    "flag": "🇫🇯",
    "flag_url": "https://flagcdn.com/w320/fj.png",
    "language_code": "en",
    "currency_code": "FJD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Finland",
    "iso2": "FI",
    "iso3": "FIN",
    "phone_code": "358",
    "division_type": "Region",
    "flag": "🇫🇮",
    "flag_url": "https://flagcdn.com/w320/fi.png",
    "language_code": "fi",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "France",
    "iso2": "FR",
    "iso3": "FRA",
    "phone_code": "33",
    "division_type": "Dependency or European collectivity or Metropolitan collectivity with special status or Metropolitan department or Metropolitan region or Overseas collectivity or Overseas collectivity with special status or Overseas region or Overseas territory",
    "flag": "🇫🇷",
    "flag_url": "https://flagcdn.com/w320/fr.png",
    "language_code": "fr-FR",
    "currency_code": "EUR",
    "tax_id_label": "SIRET / TVA",
    "tax_id_placeholder": "000 000 000 00000",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "French Guiana",
    "iso2": "GF",
    "iso3": "GUF",
    "phone_code": "594",
    "division_type": "Overseas region",
    "flag": "🇬🇫",
    "flag_url": "https://flagcdn.com/w320/gf.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "French Polynesia",
    "iso2": "PF",
    "iso3": "PYF",
    "phone_code": "689",
    "division_type": "Division",
    "flag": "🇵🇫",
    "flag_url": "https://flagcdn.com/w320/pf.png",
    "language_code": "fr",
    "currency_code": "XPF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "French Southern Territories",
    "iso2": "TF",
    "iso3": "ATF",
    "phone_code": "262",
    "division_type": "District",
    "flag": "🇹🇫",
    "flag_url": "https://flagcdn.com/w320/tf.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Gabon",
    "iso2": "GA",
    "iso3": "GAB",
    "phone_code": "241",
    "division_type": "Province",
    "flag": "🇬🇦",
    "flag_url": "https://flagcdn.com/w320/ga.png",
    "language_code": "fr",
    "currency_code": "XAF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Georgia",
    "iso2": "GE",
    "iso3": "GEO",
    "phone_code": "995",
    "division_type": "Autonomous republic or City or Region",
    "flag": "🇬🇪",
    "flag_url": "https://flagcdn.com/w320/ge.png",
    "language_code": "ka",
    "currency_code": "GEL",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Germany",
    "iso2": "DE",
    "iso3": "DEU",
    "phone_code": "49",
    "division_type": "Land",
    "flag": "🇩🇪",
    "flag_url": "https://flagcdn.com/w320/de.png",
    "language_code": "de",
    "currency_code": "EUR",
    "tax_id_label": "Steuernummer / USt-IdNr.",
    "tax_id_placeholder": "DE000000000",
    "postal_code_label": "PLZ",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Ghana",
    "iso2": "GH",
    "iso3": "GHA",
    "phone_code": "233",
    "division_type": "Region",
    "flag": "🇬🇭",
    "flag_url": "https://flagcdn.com/w320/gh.png",
    "language_code": "en",
    "currency_code": "GHS",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Gibraltar",
    "iso2": "GI",
    "iso3": "GIB",
    "phone_code": "350",
    "division_type": "",
    "flag": "🇬🇮",
    "flag_url": "https://flagcdn.com/w320/gi.png",
    "language_code": "en",
    "currency_code": "GIP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Greece",
    "iso2": "GR",
    "iso3": "GRC",
    "phone_code": "30",
    "division_type": "Administrative region or Regional unit",
    "flag": "🇬🇷",
    "flag_url": "https://flagcdn.com/w320/gr.png",
    "language_code": "el",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Greenland",
    "iso2": "GL",
    "iso3": "GRL",
    "phone_code": "299",
    "division_type": "Municipality",
    "flag": "🇬🇱",
    "flag_url": "https://flagcdn.com/w320/gl.png",
    "language_code": "kl",
    "currency_code": "DKK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-MM-DD",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Grenada",
    "iso2": "GD",
    "iso3": "GRD",
    "phone_code": "1",
    "division_type": "Dependency or Parish",
    "flag": "🇬🇩",
    "flag_url": "https://flagcdn.com/w320/gd.png",
    "language_code": "en",
    "currency_code": "XCD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Guadeloupe",
    "iso2": "GP",
    "iso3": "GLP",
    "phone_code": "590",
    "division_type": "District",
    "flag": "🇬🇵",
    "flag_url": "https://flagcdn.com/w320/gp.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Guam",
    "iso2": "GU",
    "iso3": "GUM",
    "phone_code": "1",
    "division_type": "Village",
    "flag": "🇬🇺",
    "flag_url": "https://flagcdn.com/w320/gu.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Guatemala",
    "iso2": "GT",
    "iso3": "GTM",
    "phone_code": "502",
    "division_type": "Department",
    "flag": "🇬🇹",
    "flag_url": "https://flagcdn.com/w320/gt.png",
    "language_code": "es",
    "currency_code": "GTQ",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Guernsey",
    "iso2": "GG",
    "iso3": "GGY",
    "phone_code": "44",
    "division_type": "Parish",
    "flag": "🇬🇬",
    "flag_url": "https://flagcdn.com/w320/gg.png",
    "language_code": "en",
    "currency_code": "GBP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Guinea",
    "iso2": "GN",
    "iso3": "GIN",
    "phone_code": "224",
    "division_type": "Administrative region or Governorate or Prefecture",
    "flag": "🇬🇳",
    "flag_url": "https://flagcdn.com/w320/gn.png",
    "language_code": "fr",
    "currency_code": "GNF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Guinea-Bissau",
    "iso2": "GW",
    "iso3": "GNB",
    "phone_code": "245",
    "division_type": "Autonomous sector or Province or Region",
    "flag": "🇬🇼",
    "flag_url": "https://flagcdn.com/w320/gw.png",
    "language_code": "pt",
    "currency_code": "XOF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Guyana",
    "iso2": "GY",
    "iso3": "GUY",
    "phone_code": "592",
    "division_type": "Region",
    "flag": "🇬🇾",
    "flag_url": "https://flagcdn.com/w320/gy.png",
    "language_code": "en",
    "currency_code": "GYD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Haiti",
    "iso2": "HT",
    "iso3": "HTI",
    "phone_code": "509",
    "division_type": "Department",
    "flag": "🇭🇹",
    "flag_url": "https://flagcdn.com/w320/ht.png",
    "language_code": "fr",
    "currency_code": "HTG",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Heard Island and McDonald Islands",
    "iso2": "HM",
    "iso3": "HMD",
    "phone_code": "672",
    "division_type": "",
    "flag": "🇭🇲",
    "flag_url": "https://flagcdn.com/w320/hm.png",
    "language_code": "en",
    "currency_code": "AUD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Honduras",
    "iso2": "HN",
    "iso3": "HND",
    "phone_code": "504",
    "division_type": "Department",
    "flag": "🇭🇳",
    "flag_url": "https://flagcdn.com/w320/hn.png",
    "language_code": "es",
    "currency_code": "HNL",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Hong Kong S.A.R.",
    "iso2": "HK",
    "iso3": "HKG",
    "phone_code": "852",
    "division_type": "District",
    "flag": "🇭🇰",
    "flag_url": "https://flagcdn.com/w320/hk.png",
    "language_code": "zh-HK",
    "currency_code": "HKD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Hungary",
    "iso2": "HU",
    "iso3": "HUN",
    "phone_code": "36",
    "division_type": "Capital city or City with county rights or County",
    "flag": "🇭🇺",
    "flag_url": "https://flagcdn.com/w320/hu.png",
    "language_code": "hu",
    "currency_code": "HUF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY.MM.DD",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Iceland",
    "iso2": "IS",
    "iso3": "ISL",
    "phone_code": "354",
    "division_type": "Municipality or Region",
    "flag": "🇮🇸",
    "flag_url": "https://flagcdn.com/w320/is.png",
    "language_code": "is",
    "currency_code": "ISK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 0
  },
  {
    "name": "India",
    "iso2": "IN",
    "iso3": "IND",
    "phone_code": "91",
    "division_type": "State or Union territory",
    "flag": "🇮🇳",
    "flag_url": "https://flagcdn.com/w320/in.png",
    "language_code": "hi",
    "currency_code": "INR",
    "tax_id_label": "GSTIN / PAN",
    "tax_id_placeholder": "00AAAAA0000A0A0",
    "postal_code_label": "PIN Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Indonesia",
    "iso2": "ID",
    "iso3": "IDN",
    "phone_code": "62",
    "division_type": "Capital district or Geographical unit or Province or Special region",
    "flag": "🇮🇩",
    "flag_url": "https://flagcdn.com/w320/id.png",
    "language_code": "id",
    "currency_code": "IDR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Iran",
    "iso2": "IR",
    "iso3": "IRN",
    "phone_code": "98",
    "division_type": "Province",
    "flag": "🇮🇷",
    "flag_url": "https://flagcdn.com/w320/ir.png",
    "language_code": "fa",
    "currency_code": "IRR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY/MM/DD",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Iraq",
    "iso2": "IQ",
    "iso3": "IRQ",
    "phone_code": "964",
    "division_type": "Governorate or Region",
    "flag": "🇮🇶",
    "flag_url": "https://flagcdn.com/w320/iq.png",
    "language_code": "ar",
    "currency_code": "IQD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Ireland",
    "iso2": "IE",
    "iso3": "IRL",
    "phone_code": "353",
    "division_type": "County or Province",
    "flag": "🇮🇪",
    "flag_url": "https://flagcdn.com/w320/ie.png",
    "language_code": "en",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Israel",
    "iso2": "IL",
    "iso3": "ISR",
    "phone_code": "972",
    "division_type": "District",
    "flag": "🇮🇱",
    "flag_url": "https://flagcdn.com/w320/il.png",
    "language_code": "he",
    "currency_code": "ILS",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 0
  },
  {
    "name": "Italy",
    "iso2": "IT",
    "iso3": "ITA",
    "phone_code": "39",
    "division_type": "Autonomous province or Autonomous region or Decentralized regional entity or Free municipal consortium or Metropolitan city or Province or Region",
    "flag": "🇮🇹",
    "flag_url": "https://flagcdn.com/w320/it.png",
    "language_code": "it",
    "currency_code": "EUR",
    "tax_id_label": "Partita IVA",
    "tax_id_placeholder": "IT00000000000",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Ivory Coast",
    "iso2": "CI",
    "iso3": "CIV",
    "phone_code": "225",
    "division_type": "Autonomous district or District",
    "flag": "🇨🇮",
    "flag_url": "https://flagcdn.com/w320/ci.png",
    "language_code": "fr",
    "currency_code": "XOF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Jamaica",
    "iso2": "JM",
    "iso3": "JAM",
    "phone_code": "1",
    "division_type": "Parish",
    "flag": "🇯🇲",
    "flag_url": "https://flagcdn.com/w320/jm.png",
    "language_code": "en",
    "currency_code": "JMD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Japan",
    "iso2": "JP",
    "iso3": "JPN",
    "phone_code": "81",
    "division_type": "Prefecture",
    "flag": "🇯🇵",
    "flag_url": "https://flagcdn.com/w320/jp.png",
    "language_code": "ja",
    "currency_code": "JPY",
    "tax_id_label": "Corporation Number",
    "tax_id_placeholder": "0000000000000",
    "postal_code_label": "Postal Code (〒)",
    "date_format": "YYYY/MM/DD",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Jersey",
    "iso2": "JE",
    "iso3": "JEY",
    "phone_code": "44",
    "division_type": "Parish",
    "flag": "🇯🇪",
    "flag_url": "https://flagcdn.com/w320/je.png",
    "language_code": "en",
    "currency_code": "GBP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Jordan",
    "iso2": "JO",
    "iso3": "JOR",
    "phone_code": "962",
    "division_type": "Governorate",
    "flag": "🇯🇴",
    "flag_url": "https://flagcdn.com/w320/jo.png",
    "language_code": "ar",
    "currency_code": "JOD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Kazakhstan",
    "iso2": "KZ",
    "iso3": "KAZ",
    "phone_code": "7",
    "division_type": "City or Region",
    "flag": "🇰🇿",
    "flag_url": "https://flagcdn.com/w320/kz.png",
    "language_code": "kk",
    "currency_code": "KZT",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Kenya",
    "iso2": "KE",
    "iso3": "KEN",
    "phone_code": "254",
    "division_type": "County",
    "flag": "🇰🇪",
    "flag_url": "https://flagcdn.com/w320/ke.png",
    "language_code": "sw",
    "currency_code": "KES",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Kiribati",
    "iso2": "KI",
    "iso3": "KIR",
    "phone_code": "686",
    "division_type": "Island",
    "flag": "🇰🇮",
    "flag_url": "https://flagcdn.com/w320/ki.png",
    "language_code": "en",
    "currency_code": "AUD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Kosovo",
    "iso2": "XK",
    "iso3": "XKX",
    "phone_code": "383",
    "division_type": "District",
    "flag": "🇽🇰",
    "flag_url": "https://flagcdn.com/w320/xk.png",
    "language_code": "en",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Kuwait",
    "iso2": "KW",
    "iso3": "KWT",
    "phone_code": "965",
    "division_type": "Governorate",
    "flag": "🇰🇼",
    "flag_url": "https://flagcdn.com/w320/kw.png",
    "language_code": "ar",
    "currency_code": "KWD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Kyrgyzstan",
    "iso2": "KG",
    "iso3": "KGZ",
    "phone_code": "996",
    "division_type": "City or Region",
    "flag": "🇰🇬",
    "flag_url": "https://flagcdn.com/w320/kg.png",
    "language_code": "ky",
    "currency_code": "KGS",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-DD-MM",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Laos",
    "iso2": "LA",
    "iso3": "LAO",
    "phone_code": "856",
    "division_type": "Prefecture or Province",
    "flag": "🇱🇦",
    "flag_url": "https://flagcdn.com/w320/la.png",
    "language_code": "lo",
    "currency_code": "LAK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Latvia",
    "iso2": "LV",
    "iso3": "LVA",
    "phone_code": "371",
    "division_type": "Municipality or State city",
    "flag": "🇱🇻",
    "flag_url": "https://flagcdn.com/w320/lv.png",
    "language_code": "lv",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Lebanon",
    "iso2": "LB",
    "iso3": "LBN",
    "phone_code": "961",
    "division_type": "Governorate",
    "flag": "🇱🇧",
    "flag_url": "https://flagcdn.com/w320/lb.png",
    "language_code": "ar",
    "currency_code": "LBP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Lesotho",
    "iso2": "LS",
    "iso3": "LSO",
    "phone_code": "266",
    "division_type": "District",
    "flag": "🇱🇸",
    "flag_url": "https://flagcdn.com/w320/ls.png",
    "language_code": "en",
    "currency_code": "LSL",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Liberia",
    "iso2": "LR",
    "iso3": "LBR",
    "phone_code": "231",
    "division_type": "County",
    "flag": "🇱🇷",
    "flag_url": "https://flagcdn.com/w320/lr.png",
    "language_code": "en",
    "currency_code": "LRD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Libya",
    "iso2": "LY",
    "iso3": "LBY",
    "phone_code": "218",
    "division_type": "Popularate",
    "flag": "🇱🇾",
    "flag_url": "https://flagcdn.com/w320/ly.png",
    "language_code": "ar",
    "currency_code": "LYD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Liechtenstein",
    "iso2": "LI",
    "iso3": "LIE",
    "phone_code": "423",
    "division_type": "Commune",
    "flag": "🇱🇮",
    "flag_url": "https://flagcdn.com/w320/li.png",
    "language_code": "de",
    "currency_code": "CHF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Lithuania",
    "iso2": "LT",
    "iso3": "LTU",
    "phone_code": "370",
    "division_type": "City municipality or County or District municipality or Municipality",
    "flag": "🇱🇹",
    "flag_url": "https://flagcdn.com/w320/lt.png",
    "language_code": "lt",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-MM-DD",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Luxembourg",
    "iso2": "LU",
    "iso3": "LUX",
    "phone_code": "352",
    "division_type": "Canton",
    "flag": "🇱🇺",
    "flag_url": "https://flagcdn.com/w320/lu.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Macau S.A.R.",
    "iso2": "MO",
    "iso3": "MAC",
    "phone_code": "853",
    "division_type": "",
    "flag": "🇲🇴",
    "flag_url": "https://flagcdn.com/w320/mo.png",
    "language_code": "zh-MO",
    "currency_code": "MOP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Madagascar",
    "iso2": "MG",
    "iso3": "MDG",
    "phone_code": "261",
    "division_type": "Province",
    "flag": "🇲🇬",
    "flag_url": "https://flagcdn.com/w320/mg.png",
    "language_code": "fr",
    "currency_code": "MGA",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Malawi",
    "iso2": "MW",
    "iso3": "MWI",
    "phone_code": "265",
    "division_type": "District or Region",
    "flag": "🇲🇼",
    "flag_url": "https://flagcdn.com/w320/mw.png",
    "language_code": "en",
    "currency_code": "MWK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Malaysia",
    "iso2": "MY",
    "iso3": "MYS",
    "phone_code": "60",
    "division_type": "Federal territory or State",
    "flag": "🇲🇾",
    "flag_url": "https://flagcdn.com/w320/my.png",
    "language_code": "ms",
    "currency_code": "MYR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Maldives",
    "iso2": "MV",
    "iso3": "MDV",
    "phone_code": "960",
    "division_type": "Administrative atoll or City",
    "flag": "🇲🇻",
    "flag_url": "https://flagcdn.com/w320/mv.png",
    "language_code": "dv",
    "currency_code": "MVR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 5
  },
  {
    "name": "Mali",
    "iso2": "ML",
    "iso3": "MLI",
    "phone_code": "223",
    "division_type": "District or Region",
    "flag": "🇲🇱",
    "flag_url": "https://flagcdn.com/w320/ml.png",
    "language_code": "fr",
    "currency_code": "XOF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Malta",
    "iso2": "MT",
    "iso3": "MLT",
    "phone_code": "356",
    "division_type": "Local council",
    "flag": "🇲🇹",
    "flag_url": "https://flagcdn.com/w320/mt.png",
    "language_code": "mt",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Man (Isle of)",
    "iso2": "IM",
    "iso3": "IMN",
    "phone_code": "44",
    "division_type": "Sheadings",
    "flag": "🇮🇲",
    "flag_url": "https://flagcdn.com/w320/im.png",
    "language_code": "en",
    "currency_code": "GBP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Marshall Islands",
    "iso2": "MH",
    "iso3": "MHL",
    "phone_code": "692",
    "division_type": "Chain or Municipality",
    "flag": "🇲🇭",
    "flag_url": "https://flagcdn.com/w320/mh.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Martinique",
    "iso2": "MQ",
    "iso3": "MTQ",
    "phone_code": "596",
    "division_type": "District",
    "flag": "🇲🇶",
    "flag_url": "https://flagcdn.com/w320/mq.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Mauritania",
    "iso2": "MR",
    "iso3": "MRT",
    "phone_code": "222",
    "division_type": "Region",
    "flag": "🇲🇷",
    "flag_url": "https://flagcdn.com/w320/mr.png",
    "language_code": "ar",
    "currency_code": "MRU",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Mauritius",
    "iso2": "MU",
    "iso3": "MUS",
    "phone_code": "230",
    "division_type": "Dependency or District",
    "flag": "🇲🇺",
    "flag_url": "https://flagcdn.com/w320/mu.png",
    "language_code": "en",
    "currency_code": "MUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Mayotte",
    "iso2": "YT",
    "iso3": "MYT",
    "phone_code": "262",
    "division_type": "Commune",
    "flag": "🇾🇹",
    "flag_url": "https://flagcdn.com/w320/yt.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Mexico",
    "iso2": "MX",
    "iso3": "MEX",
    "phone_code": "52",
    "division_type": "Federal district or State",
    "flag": "🇲🇽",
    "flag_url": "https://flagcdn.com/w320/mx.png",
    "language_code": "es-MX",
    "currency_code": "MXN",
    "tax_id_label": "RFC",
    "tax_id_placeholder": "AAAA000000AA0",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Micronesia",
    "iso2": "FM",
    "iso3": "FSM",
    "phone_code": "691",
    "division_type": "State",
    "flag": "🇫🇲",
    "flag_url": "https://flagcdn.com/w320/fm.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Moldova",
    "iso2": "MD",
    "iso3": "MDA",
    "phone_code": "373",
    "division_type": "Autonomous territorial unit or City or District or Territorial unit",
    "flag": "🇲🇩",
    "flag_url": "https://flagcdn.com/w320/md.png",
    "language_code": "ro",
    "currency_code": "MDL",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Monaco",
    "iso2": "MC",
    "iso3": "MCO",
    "phone_code": "377",
    "division_type": "Quarter",
    "flag": "🇲🇨",
    "flag_url": "https://flagcdn.com/w320/mc.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Mongolia",
    "iso2": "MN",
    "iso3": "MNG",
    "phone_code": "976",
    "division_type": "Capital city or Province",
    "flag": "🇲🇳",
    "flag_url": "https://flagcdn.com/w320/mn.png",
    "language_code": "mn",
    "currency_code": "MNT",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY.MM.DD",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Montenegro",
    "iso2": "ME",
    "iso3": "MNE",
    "phone_code": "382",
    "division_type": "Municipality",
    "flag": "🇲🇪",
    "flag_url": "https://flagcdn.com/w320/me.png",
    "language_code": "sr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Montserrat",
    "iso2": "MS",
    "iso3": "MSR",
    "phone_code": "1",
    "division_type": "Parish",
    "flag": "🇲🇸",
    "flag_url": "https://flagcdn.com/w320/ms.png",
    "language_code": "en",
    "currency_code": "XCD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Morocco",
    "iso2": "MA",
    "iso3": "MAR",
    "phone_code": "212",
    "division_type": "Prefecture or Province or Region",
    "flag": "🇲🇦",
    "flag_url": "https://flagcdn.com/w320/ma.png",
    "language_code": "ar",
    "currency_code": "MAD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Mozambique",
    "iso2": "MZ",
    "iso3": "MOZ",
    "phone_code": "258",
    "division_type": "City or Province",
    "flag": "🇲🇿",
    "flag_url": "https://flagcdn.com/w320/mz.png",
    "language_code": "pt",
    "currency_code": "MZN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Myanmar",
    "iso2": "MM",
    "iso3": "MMR",
    "phone_code": "95",
    "division_type": "Region or State or Union territory",
    "flag": "🇲🇲",
    "flag_url": "https://flagcdn.com/w320/mm.png",
    "language_code": "my",
    "currency_code": "MMK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Namibia",
    "iso2": "NA",
    "iso3": "NAM",
    "phone_code": "264",
    "division_type": "Region",
    "flag": "🇳🇦",
    "flag_url": "https://flagcdn.com/w320/na.png",
    "language_code": "en",
    "currency_code": "NAD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Nauru",
    "iso2": "NR",
    "iso3": "NRU",
    "phone_code": "674",
    "division_type": "District",
    "flag": "🇳🇷",
    "flag_url": "https://flagcdn.com/w320/nr.png",
    "language_code": "en",
    "currency_code": "AUD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Nepal",
    "iso2": "NP",
    "iso3": "NPL",
    "phone_code": "977",
    "division_type": "Province",
    "flag": "🇳🇵",
    "flag_url": "https://flagcdn.com/w320/np.png",
    "language_code": "ne",
    "currency_code": "NPR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-MM-DD",
    "date_separator": "-",
    "week_start": 0
  },
  {
    "name": "Netherlands",
    "iso2": "NL",
    "iso3": "NLD",
    "phone_code": "31",
    "division_type": "Province",
    "flag": "🇳🇱",
    "flag_url": "https://flagcdn.com/w320/nl.png",
    "language_code": "nl",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD-MM-YYYY",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "New Caledonia",
    "iso2": "NC",
    "iso3": "NCL",
    "phone_code": "687",
    "division_type": "Province",
    "flag": "🇳🇨",
    "flag_url": "https://flagcdn.com/w320/nc.png",
    "language_code": "fr",
    "currency_code": "XPF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "New Zealand",
    "iso2": "NZ",
    "iso3": "NZL",
    "phone_code": "64",
    "division_type": "Region or Special island authority",
    "flag": "🇳🇿",
    "flag_url": "https://flagcdn.com/w320/nz.png",
    "language_code": "en",
    "currency_code": "NZD",
    "tax_id_label": "NZBN / IRD Number",
    "tax_id_placeholder": "000-000-000",
    "postal_code_label": "Postcode",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Nicaragua",
    "iso2": "NI",
    "iso3": "NIC",
    "phone_code": "505",
    "division_type": "Autonomous region or Department",
    "flag": "🇳🇮",
    "flag_url": "https://flagcdn.com/w320/ni.png",
    "language_code": "es",
    "currency_code": "NIO",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Niger",
    "iso2": "NE",
    "iso3": "NER",
    "phone_code": "227",
    "division_type": "Region or Urban community",
    "flag": "🇳🇪",
    "flag_url": "https://flagcdn.com/w320/ne.png",
    "language_code": "fr",
    "currency_code": "XOF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Nigeria",
    "iso2": "NG",
    "iso3": "NGA",
    "phone_code": "234",
    "division_type": "Capital territory or State",
    "flag": "🇳🇬",
    "flag_url": "https://flagcdn.com/w320/ng.png",
    "language_code": "en",
    "currency_code": "NGN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Niue",
    "iso2": "NU",
    "iso3": "NIU",
    "phone_code": "683",
    "division_type": "Village",
    "flag": "🇳🇺",
    "flag_url": "https://flagcdn.com/w320/nu.png",
    "language_code": "en",
    "currency_code": "NZD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Norfolk Island",
    "iso2": "NF",
    "iso3": "NFK",
    "phone_code": "672",
    "division_type": "",
    "flag": "🇳🇫",
    "flag_url": "https://flagcdn.com/w320/nf.png",
    "language_code": "en",
    "currency_code": "AUD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "North Korea",
    "iso2": "KP",
    "iso3": "PRK",
    "phone_code": "850",
    "division_type": "Capital city or Metropolitan city or Province or Special city",
    "flag": "🇰🇵",
    "flag_url": "https://flagcdn.com/w320/kp.png",
    "language_code": "ko",
    "currency_code": "KPW",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY.MM.DD",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "North Macedonia",
    "iso2": "MK",
    "iso3": "MKD",
    "phone_code": "389",
    "division_type": "Municipality",
    "flag": "🇲🇰",
    "flag_url": "https://flagcdn.com/w320/mk.png",
    "language_code": "mk",
    "currency_code": "MKD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Northern Mariana Islands",
    "iso2": "MP",
    "iso3": "MNP",
    "phone_code": "1",
    "division_type": "",
    "flag": "🇲🇵",
    "flag_url": "https://flagcdn.com/w320/mp.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Norway",
    "iso2": "NO",
    "iso3": "NOR",
    "phone_code": "47",
    "division_type": "Arctic region or County",
    "flag": "🇳🇴",
    "flag_url": "https://flagcdn.com/w320/no.png",
    "language_code": "no",
    "currency_code": "NOK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Oman",
    "iso2": "OM",
    "iso3": "OMN",
    "phone_code": "968",
    "division_type": "Governorate",
    "flag": "🇴🇲",
    "flag_url": "https://flagcdn.com/w320/om.png",
    "language_code": "ar",
    "currency_code": "OMR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Pakistan",
    "iso2": "PK",
    "iso3": "PAK",
    "phone_code": "92",
    "division_type": "Administered area or Federal capital territory or Province",
    "flag": "🇵🇰",
    "flag_url": "https://flagcdn.com/w320/pk.png",
    "language_code": "ur",
    "currency_code": "PKR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Palau",
    "iso2": "PW",
    "iso3": "PLW",
    "phone_code": "680",
    "division_type": "State",
    "flag": "🇵🇼",
    "flag_url": "https://flagcdn.com/w320/pw.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Palestinian Territory Occupied",
    "iso2": "PS",
    "iso3": "PSE",
    "phone_code": "970",
    "division_type": "Governorate",
    "flag": "🇵🇸",
    "flag_url": "https://flagcdn.com/w320/ps.png",
    "language_code": "ar",
    "currency_code": "ILS",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Panama",
    "iso2": "PA",
    "iso3": "PAN",
    "phone_code": "507",
    "division_type": "Indigenous region or Province",
    "flag": "🇵🇦",
    "flag_url": "https://flagcdn.com/w320/pa.png",
    "language_code": "es",
    "currency_code": "PAB",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Papua New Guinea",
    "iso2": "PG",
    "iso3": "PNG",
    "phone_code": "675",
    "division_type": "Autonomous region or District or Province",
    "flag": "🇵🇬",
    "flag_url": "https://flagcdn.com/w320/pg.png",
    "language_code": "en",
    "currency_code": "PGK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Paraguay",
    "iso2": "PY",
    "iso3": "PRY",
    "phone_code": "595",
    "division_type": "Department",
    "flag": "🇵🇾",
    "flag_url": "https://flagcdn.com/w320/py.png",
    "language_code": "es",
    "currency_code": "PYG",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Peru",
    "iso2": "PE",
    "iso3": "PER",
    "phone_code": "51",
    "division_type": "Municipality or Region",
    "flag": "🇵🇪",
    "flag_url": "https://flagcdn.com/w320/pe.png",
    "language_code": "es",
    "currency_code": "PEN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Philippines",
    "iso2": "PH",
    "iso3": "PHL",
    "phone_code": "63",
    "division_type": "Province or Region",
    "flag": "🇵🇭",
    "flag_url": "https://flagcdn.com/w320/ph.png",
    "language_code": "fil",
    "currency_code": "PHP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Pitcairn Island",
    "iso2": "PN",
    "iso3": "PCN",
    "phone_code": "870",
    "division_type": "",
    "flag": "🇵🇳",
    "flag_url": "https://flagcdn.com/w320/pn.png",
    "language_code": "en",
    "currency_code": "NZD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Poland",
    "iso2": "PL",
    "iso3": "POL",
    "phone_code": "48",
    "division_type": "Voivodship",
    "flag": "🇵🇱",
    "flag_url": "https://flagcdn.com/w320/pl.png",
    "language_code": "pl",
    "currency_code": "PLN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Portugal",
    "iso2": "PT",
    "iso3": "PRT",
    "phone_code": "351",
    "division_type": "Autonomous region or District",
    "flag": "🇵🇹",
    "flag_url": "https://flagcdn.com/w320/pt.png",
    "language_code": "pt-PT",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Puerto Rico",
    "iso2": "PR",
    "iso3": "PRI",
    "phone_code": "1",
    "division_type": "Municipality or Region",
    "flag": "🇵🇷",
    "flag_url": "https://flagcdn.com/w320/pr.png",
    "language_code": "es",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Qatar",
    "iso2": "QA",
    "iso3": "QAT",
    "phone_code": "974",
    "division_type": "Municipality",
    "flag": "🇶🇦",
    "flag_url": "https://flagcdn.com/w320/qa.png",
    "language_code": "ar",
    "currency_code": "QAR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Reunion",
    "iso2": "RE",
    "iso3": "REU",
    "phone_code": "262",
    "division_type": "District",
    "flag": "🇷🇪",
    "flag_url": "https://flagcdn.com/w320/re.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Romania",
    "iso2": "RO",
    "iso3": "ROU",
    "phone_code": "40",
    "division_type": "Department or Municipality",
    "flag": "🇷🇴",
    "flag_url": "https://flagcdn.com/w320/ro.png",
    "language_code": "ro",
    "currency_code": "RON",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Russia",
    "iso2": "RU",
    "iso3": "RUS",
    "phone_code": "7",
    "division_type": "Administrative region or Administrative territory or Autonomous city or Autonomous district or Autonomous region or Republic",
    "flag": "🇷🇺",
    "flag_url": "https://flagcdn.com/w320/ru.png",
    "language_code": "ru",
    "currency_code": "RUB",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Rwanda",
    "iso2": "RW",
    "iso3": "RWA",
    "phone_code": "250",
    "division_type": "City or Province",
    "flag": "🇷🇼",
    "flag_url": "https://flagcdn.com/w320/rw.png",
    "language_code": "rw",
    "currency_code": "RWF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-MM-DD",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Saint Helena",
    "iso2": "SH",
    "iso3": "SHN",
    "phone_code": "290",
    "division_type": "District",
    "flag": "🇸🇭",
    "flag_url": "https://flagcdn.com/w320/sh.png",
    "language_code": "en",
    "currency_code": "SHP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Saint Kitts and Nevis",
    "iso2": "KN",
    "iso3": "KNA",
    "phone_code": "1",
    "division_type": "Parish or State",
    "flag": "🇰🇳",
    "flag_url": "https://flagcdn.com/w320/kn.png",
    "language_code": "en",
    "currency_code": "XCD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Saint Lucia",
    "iso2": "LC",
    "iso3": "LCA",
    "phone_code": "1",
    "division_type": "District",
    "flag": "🇱🇨",
    "flag_url": "https://flagcdn.com/w320/lc.png",
    "language_code": "en",
    "currency_code": "XCD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Saint Pierre and Miquelon",
    "iso2": "PM",
    "iso3": "SPM",
    "phone_code": "508",
    "division_type": "Overseas collectivity",
    "flag": "🇵🇲",
    "flag_url": "https://flagcdn.com/w320/pm.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "iso2": "VC",
    "iso3": "VCT",
    "phone_code": "1",
    "division_type": "Parish",
    "flag": "🇻🇨",
    "flag_url": "https://flagcdn.com/w320/vc.png",
    "language_code": "en",
    "currency_code": "XCD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Saint-Barthelemy",
    "iso2": "BL",
    "iso3": "BLM",
    "phone_code": "590",
    "division_type": "Overseas collectivity",
    "flag": "🇧🇱",
    "flag_url": "https://flagcdn.com/w320/bl.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Saint-Martin (French part)",
    "iso2": "MF",
    "iso3": "MAF",
    "phone_code": "590",
    "division_type": "Overseas collectivity",
    "flag": "🇲🇫",
    "flag_url": "https://flagcdn.com/w320/mf.png",
    "language_code": "fr",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Samoa",
    "iso2": "WS",
    "iso3": "WSM",
    "phone_code": "685",
    "division_type": "District",
    "flag": "🇼🇸",
    "flag_url": "https://flagcdn.com/w320/ws.png",
    "language_code": "sm",
    "currency_code": "WST",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "San Marino",
    "iso2": "SM",
    "iso3": "SMR",
    "phone_code": "378",
    "division_type": "Municipality",
    "flag": "🇸🇲",
    "flag_url": "https://flagcdn.com/w320/sm.png",
    "language_code": "it",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Sao Tome and Principe",
    "iso2": "ST",
    "iso3": "STP",
    "phone_code": "239",
    "division_type": "Autonomous region or District",
    "flag": "🇸🇹",
    "flag_url": "https://flagcdn.com/w320/st.png",
    "language_code": "pt",
    "currency_code": "STN",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Saudi Arabia",
    "iso2": "SA",
    "iso3": "SAU",
    "phone_code": "966",
    "division_type": "Region",
    "flag": "🇸🇦",
    "flag_url": "https://flagcdn.com/w320/sa.png",
    "language_code": "ar",
    "currency_code": "SAR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Senegal",
    "iso2": "SN",
    "iso3": "SEN",
    "phone_code": "221",
    "division_type": "Region",
    "flag": "🇸🇳",
    "flag_url": "https://flagcdn.com/w320/sn.png",
    "language_code": "fr",
    "currency_code": "XOF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Serbia",
    "iso2": "RS",
    "iso3": "SRB",
    "phone_code": "381",
    "division_type": "City or District or Province",
    "flag": "🇷🇸",
    "flag_url": "https://flagcdn.com/w320/rs.png",
    "language_code": "sr",
    "currency_code": "RSD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Seychelles",
    "iso2": "SC",
    "iso3": "SYC",
    "phone_code": "248",
    "division_type": "District",
    "flag": "🇸🇨",
    "flag_url": "https://flagcdn.com/w320/sc.png",
    "language_code": "fr",
    "currency_code": "SCR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Sierra Leone",
    "iso2": "SL",
    "iso3": "SLE",
    "phone_code": "232",
    "division_type": "Area or Province",
    "flag": "🇸🇱",
    "flag_url": "https://flagcdn.com/w320/sl.png",
    "language_code": "en",
    "currency_code": "SLL",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Singapore",
    "iso2": "SG",
    "iso3": "SGP",
    "phone_code": "65",
    "division_type": "District",
    "flag": "🇸🇬",
    "flag_url": "https://flagcdn.com/w320/sg.png",
    "language_code": "zh-SG",
    "currency_code": "SGD",
    "tax_id_label": "UEN",
    "tax_id_placeholder": "000000000A",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Sint Maarten (Dutch part)",
    "iso2": "SX",
    "iso3": "SXM",
    "phone_code": "1721",
    "division_type": "",
    "flag": "🇸🇽",
    "flag_url": "https://flagcdn.com/w320/sx.png",
    "language_code": "nl",
    "currency_code": "ANG",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD-MM-YYYY",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Slovakia",
    "iso2": "SK",
    "iso3": "SVK",
    "phone_code": "421",
    "division_type": "Region",
    "flag": "🇸🇰",
    "flag_url": "https://flagcdn.com/w320/sk.png",
    "language_code": "sk",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Slovenia",
    "iso2": "SI",
    "iso3": "SVN",
    "phone_code": "386",
    "division_type": "Municipality or Urban municipality",
    "flag": "🇸🇮",
    "flag_url": "https://flagcdn.com/w320/si.png",
    "language_code": "sl",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Solomon Islands",
    "iso2": "SB",
    "iso3": "SLB",
    "phone_code": "677",
    "division_type": "Capital territory or Province",
    "flag": "🇸🇧",
    "flag_url": "https://flagcdn.com/w320/sb.png",
    "language_code": "en",
    "currency_code": "SBD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Somalia",
    "iso2": "SO",
    "iso3": "SOM",
    "phone_code": "252",
    "division_type": "Region",
    "flag": "🇸🇴",
    "flag_url": "https://flagcdn.com/w320/so.png",
    "language_code": "so",
    "currency_code": "SOS",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "South Africa",
    "iso2": "ZA",
    "iso3": "ZAF",
    "phone_code": "27",
    "division_type": "Province",
    "flag": "🇿🇦",
    "flag_url": "https://flagcdn.com/w320/za.png",
    "language_code": "en",
    "currency_code": "ZAR",
    "tax_id_label": "Tax Number",
    "tax_id_placeholder": "0000000000",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY/MM/DD",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "South Georgia",
    "iso2": "GS",
    "iso3": "SGS",
    "phone_code": "500",
    "division_type": "",
    "flag": "🇬🇸",
    "flag_url": "https://flagcdn.com/w320/gs.png",
    "language_code": "en",
    "currency_code": "GBP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "South Korea",
    "iso2": "KR",
    "iso3": "KOR",
    "phone_code": "82",
    "division_type": "Metropolitan city or Province or Special city or Special self-governing city or Special self-governing province",
    "flag": "🇰🇷",
    "flag_url": "https://flagcdn.com/w320/kr.png",
    "language_code": "ko",
    "currency_code": "KRW",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY.MM.DD",
    "date_separator": ".",
    "week_start": 0
  },
  {
    "name": "South Sudan",
    "iso2": "SS",
    "iso3": "SSD",
    "phone_code": "211",
    "division_type": "State",
    "flag": "🇸🇸",
    "flag_url": "https://flagcdn.com/w320/ss.png",
    "language_code": "en",
    "currency_code": "SSP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Spain",
    "iso2": "ES",
    "iso3": "ESP",
    "phone_code": "34",
    "division_type": "Autonomous city or Autonomous community or Province",
    "flag": "🇪🇸",
    "flag_url": "https://flagcdn.com/w320/es.png",
    "language_code": "es-ES",
    "currency_code": "EUR",
    "tax_id_label": "NIF / CIF",
    "tax_id_placeholder": "A00000000",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Sri Lanka",
    "iso2": "LK",
    "iso3": "LKA",
    "phone_code": "94",
    "division_type": "District or Province",
    "flag": "🇱🇰",
    "flag_url": "https://flagcdn.com/w320/lk.png",
    "language_code": "si",
    "currency_code": "LKR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-MM-DD",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Sudan",
    "iso2": "SD",
    "iso3": "SDN",
    "phone_code": "249",
    "division_type": "State",
    "flag": "🇸🇩",
    "flag_url": "https://flagcdn.com/w320/sd.png",
    "language_code": "ar",
    "currency_code": "SDG",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Suriname",
    "iso2": "SR",
    "iso3": "SUR",
    "phone_code": "597",
    "division_type": "District",
    "flag": "🇸🇷",
    "flag_url": "https://flagcdn.com/w320/sr.png",
    "language_code": "nl",
    "currency_code": "SRD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD-MM-YYYY",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Svalbard and Jan Mayen Islands",
    "iso2": "SJ",
    "iso3": "SJM",
    "phone_code": "47",
    "division_type": "",
    "flag": "🇸🇯",
    "flag_url": "https://flagcdn.com/w320/sj.png",
    "language_code": "no",
    "currency_code": "NOK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Sweden",
    "iso2": "SE",
    "iso3": "SWE",
    "phone_code": "46",
    "division_type": "County",
    "flag": "🇸🇪",
    "flag_url": "https://flagcdn.com/w320/se.png",
    "language_code": "sv",
    "currency_code": "SEK",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "YYYY-MM-DD",
    "date_separator": "-",
    "week_start": 1
  },
  {
    "name": "Switzerland",
    "iso2": "CH",
    "iso3": "CHE",
    "phone_code": "41",
    "division_type": "Canton",
    "flag": "🇨🇭",
    "flag_url": "https://flagcdn.com/w320/ch.png",
    "language_code": "de",
    "currency_code": "CHF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Syria",
    "iso2": "SY",
    "iso3": "SYR",
    "phone_code": "963",
    "division_type": "Province",
    "flag": "🇸🇾",
    "flag_url": "https://flagcdn.com/w320/sy.png",
    "language_code": "ar",
    "currency_code": "SYP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 6
  },
  {
    "name": "Taiwan",
    "iso2": "TW",
    "iso3": "TWN",
    "phone_code": "886",
    "division_type": "City or County or Special municipality",
    "flag": "🇹🇼",
    "flag_url": "https://flagcdn.com/w320/tw.png",
    "language_code": "zh-TW",
    "currency_code": "TWD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Tajikistan",
    "iso2": "TJ",
    "iso3": "TJK",
    "phone_code": "992",
    "division_type": "Autonomous region or Capital territory or Districts under republic administration or Region",
    "flag": "🇹🇯",
    "flag_url": "https://flagcdn.com/w320/tj.png",
    "language_code": "tg",
    "currency_code": "TJS",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Tanzania",
    "iso2": "TZ",
    "iso3": "TZA",
    "phone_code": "255",
    "division_type": "Region",
    "flag": "🇹🇿",
    "flag_url": "https://flagcdn.com/w320/tz.png",
    "language_code": "sw",
    "currency_code": "TZS",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Thailand",
    "iso2": "TH",
    "iso3": "THA",
    "phone_code": "66",
    "division_type": "Metropolitan administration or Province",
    "flag": "🇹🇭",
    "flag_url": "https://flagcdn.com/w320/th.png",
    "language_code": "th",
    "currency_code": "THB",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "The Bahamas",
    "iso2": "BS",
    "iso3": "BHS",
    "phone_code": "1",
    "division_type": "District or Island",
    "flag": "🇧🇸",
    "flag_url": "https://flagcdn.com/w320/bs.png",
    "language_code": "en",
    "currency_code": "BSD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "The Gambia",
    "iso2": "GM",
    "iso3": "GMB",
    "phone_code": "220",
    "division_type": "City or Division",
    "flag": "🇬🇲",
    "flag_url": "https://flagcdn.com/w320/gm.png",
    "language_code": "en",
    "currency_code": "GMD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Timor-Leste",
    "iso2": "TL",
    "iso3": "TLS",
    "phone_code": "670",
    "division_type": "Municipality or Special administrative region",
    "flag": "🇹🇱",
    "flag_url": "https://flagcdn.com/w320/tl.png",
    "language_code": "pt",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Togo",
    "iso2": "TG",
    "iso3": "TGO",
    "phone_code": "228",
    "division_type": "Region",
    "flag": "🇹🇬",
    "flag_url": "https://flagcdn.com/w320/tg.png",
    "language_code": "fr",
    "currency_code": "XOF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Tokelau",
    "iso2": "TK",
    "iso3": "TKL",
    "phone_code": "690",
    "division_type": "",
    "flag": "🇹🇰",
    "flag_url": "https://flagcdn.com/w320/tk.png",
    "language_code": "en",
    "currency_code": "NZD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Tonga",
    "iso2": "TO",
    "iso3": "TON",
    "phone_code": "676",
    "division_type": "Division",
    "flag": "🇹🇴",
    "flag_url": "https://flagcdn.com/w320/to.png",
    "language_code": "en",
    "currency_code": "TOP",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Trinidad and Tobago",
    "iso2": "TT",
    "iso3": "TTO",
    "phone_code": "1",
    "division_type": "Borough or City or Region or Ward",
    "flag": "🇹🇹",
    "flag_url": "https://flagcdn.com/w320/tt.png",
    "language_code": "en",
    "currency_code": "TTD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Tunisia",
    "iso2": "TN",
    "iso3": "TUN",
    "phone_code": "216",
    "division_type": "Governorate",
    "flag": "🇹🇳",
    "flag_url": "https://flagcdn.com/w320/tn.png",
    "language_code": "ar",
    "currency_code": "TND",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Turkey",
    "iso2": "TR",
    "iso3": "TUR",
    "phone_code": "90",
    "division_type": "Province",
    "flag": "🇹🇷",
    "flag_url": "https://flagcdn.com/w320/tr.png",
    "language_code": "tr",
    "currency_code": "TRY",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Turkmenistan",
    "iso2": "TM",
    "iso3": "TKM",
    "phone_code": "993",
    "division_type": "City or Region",
    "flag": "🇹🇲",
    "flag_url": "https://flagcdn.com/w320/tm.png",
    "language_code": "tk",
    "currency_code": "TMT",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "Turks and Caicos Islands",
    "iso2": "TC",
    "iso3": "TCA",
    "phone_code": "1",
    "division_type": "District",
    "flag": "🇹🇨",
    "flag_url": "https://flagcdn.com/w320/tc.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Tuvalu",
    "iso2": "TV",
    "iso3": "TUV",
    "phone_code": "688",
    "division_type": "Island council or Town council",
    "flag": "🇹🇻",
    "flag_url": "https://flagcdn.com/w320/tv.png",
    "language_code": "en",
    "currency_code": "AUD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Uganda",
    "iso2": "UG",
    "iso3": "UGA",
    "phone_code": "256",
    "division_type": "City or District or Region",
    "flag": "🇺🇬",
    "flag_url": "https://flagcdn.com/w320/ug.png",
    "language_code": "en",
    "currency_code": "UGX",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Ukraine",
    "iso2": "UA",
    "iso3": "UKR",
    "phone_code": "380",
    "division_type": "City or Region or Republic",
    "flag": "🇺🇦",
    "flag_url": "https://flagcdn.com/w320/ua.png",
    "language_code": "uk",
    "currency_code": "UAH",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD.MM.YYYY",
    "date_separator": ".",
    "week_start": 1
  },
  {
    "name": "United Arab Emirates",
    "iso2": "AE",
    "iso3": "ARE",
    "phone_code": "971",
    "division_type": "Emirate",
    "flag": "🇦🇪",
    "flag_url": "https://flagcdn.com/w320/ae.png",
    "language_code": "ar",
    "currency_code": "AED",
    "tax_id_label": "TRN",
    "tax_id_placeholder": "100000000000000",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "United Kingdom",
    "iso2": "GB",
    "iso3": "GBR",
    "phone_code": "44",
    "division_type": "City or Council area or Country or District or London borough or Metropolitan district or Province or Two-tier county or Unitary authority",
    "flag": "🇬🇧",
    "flag_url": "https://flagcdn.com/w320/gb.png",
    "language_code": "en-GB",
    "currency_code": "GBP",
    "tax_id_label": "UTR / Company Number",
    "tax_id_placeholder": "0000000000",
    "postal_code_label": "Postcode",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "United States",
    "iso2": "US",
    "iso3": "USA",
    "phone_code": "1",
    "division_type": "District or Military postal region or Outlying area or State",
    "flag": "🇺🇸",
    "flag_url": "https://flagcdn.com/w320/us.png",
    "language_code": "en-US",
    "currency_code": "USD",
    "tax_id_label": "EIN / SSN",
    "tax_id_placeholder": "00-0000000",
    "postal_code_label": "ZIP Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "United States Minor Outlying Islands",
    "iso2": "UM",
    "iso3": "UMI",
    "phone_code": "1",
    "division_type": "Island",
    "flag": "🇺🇲",
    "flag_url": "https://flagcdn.com/w320/um.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Uruguay",
    "iso2": "UY",
    "iso3": "URY",
    "phone_code": "598",
    "division_type": "Department",
    "flag": "🇺🇾",
    "flag_url": "https://flagcdn.com/w320/uy.png",
    "language_code": "es",
    "currency_code": "UYU",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Uzbekistan",
    "iso2": "UZ",
    "iso3": "UZB",
    "phone_code": "998",
    "division_type": "City or Region or Republic",
    "flag": "🇺🇿",
    "flag_url": "https://flagcdn.com/w320/uz.png",
    "language_code": "uz",
    "currency_code": "UZS",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Vanuatu",
    "iso2": "VU",
    "iso3": "VUT",
    "phone_code": "678",
    "division_type": "Province",
    "flag": "🇻🇺",
    "flag_url": "https://flagcdn.com/w320/vu.png",
    "language_code": "bi",
    "currency_code": "VUV",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Vatican City State (Holy See)",
    "iso2": "VA",
    "iso3": "VAT",
    "phone_code": "379",
    "division_type": "",
    "flag": "🇻🇦",
    "flag_url": "https://flagcdn.com/w320/va.png",
    "language_code": "it",
    "currency_code": "EUR",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Venezuela",
    "iso2": "VE",
    "iso3": "VEN",
    "phone_code": "58",
    "division_type": "Capital district or Federal dependency or State",
    "flag": "🇻🇪",
    "flag_url": "https://flagcdn.com/w320/ve.png",
    "language_code": "es",
    "currency_code": "VES",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Vietnam",
    "iso2": "VN",
    "iso3": "VNM",
    "phone_code": "84",
    "division_type": "Municipality or Province",
    "flag": "🇻🇳",
    "flag_url": "https://flagcdn.com/w320/vn.png",
    "language_code": "vi",
    "currency_code": "VND",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Virgin Islands (British)",
    "iso2": "VG",
    "iso3": "VGB",
    "phone_code": "1",
    "division_type": "",
    "flag": "🇻🇬",
    "flag_url": "https://flagcdn.com/w320/vg.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Virgin Islands (US)",
    "iso2": "VI",
    "iso3": "VIR",
    "phone_code": "1",
    "division_type": "District",
    "flag": "🇻🇮",
    "flag_url": "https://flagcdn.com/w320/vi.png",
    "language_code": "en",
    "currency_code": "USD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "MM/DD/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Wallis and Futuna Islands",
    "iso2": "WF",
    "iso3": "WLF",
    "phone_code": "681",
    "division_type": "Administrative precinct",
    "flag": "🇼🇫",
    "flag_url": "https://flagcdn.com/w320/wf.png",
    "language_code": "fr",
    "currency_code": "XPF",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Western Sahara",
    "iso2": "EH",
    "iso3": "ESH",
    "phone_code": "212",
    "division_type": "",
    "flag": "🇪🇭",
    "flag_url": "https://flagcdn.com/w320/eh.png",
    "language_code": "ar",
    "currency_code": "MAD",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Yemen",
    "iso2": "YE",
    "iso3": "YEM",
    "phone_code": "967",
    "division_type": "Governorate or Municipality",
    "flag": "🇾🇪",
    "flag_url": "https://flagcdn.com/w320/ye.png",
    "language_code": "ar",
    "currency_code": "YER",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  },
  {
    "name": "Zambia",
    "iso2": "ZM",
    "iso3": "ZMB",
    "phone_code": "260",
    "division_type": "Province",
    "flag": "🇿🇲",
    "flag_url": "https://flagcdn.com/w320/zm.png",
    "language_code": "en",
    "currency_code": "ZMW",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 1
  },
  {
    "name": "Zimbabwe",
    "iso2": "ZW",
    "iso3": "ZWE",
    "phone_code": "263",
    "division_type": "Province",
    "flag": "🇿🇼",
    "flag_url": "https://flagcdn.com/w320/zw.png",
    "language_code": "en",
    "currency_code": "ZWL",
    "tax_id_label": "Tax ID",
    "tax_id_placeholder": "Enter tax ID",
    "postal_code_label": "Postal Code",
    "date_format": "DD/MM/YYYY",
    "date_separator": "/",
    "week_start": 0
  }
];

export default COUNTRIES;
